import { useEffect, useState } from 'react';
import { getElementWidth, getElementHeight } from 'utils/dimensions';
import { getStageWidth } from './utils';
import { shouldHaveFeature } from '@studio/feature.flags';

function useLayoutDimensions() {
  const paddingOnSourceListWrapper = 30;
  // the default values would be set appropriately on page load in the useEffect
  const defaultStageWidth = 965;
  const defaultPageWidth = 1600;
  const defaultSourceListHeight = 304; // height of 2 rows of sources
  const [stageWidth, setStageWidth] = useState(defaultStageWidth);
  const [sourceListHeight, setSourceListHeight] = useState(
    defaultSourceListHeight
  );
  const [pageWidth, setPageWidth] = useState(defaultPageWidth);
  const otherElementsButStageHeightAndSourceList = 255;

  useEffect(() => {
    const maxWidth =
      getElementWidth('#source-list-wrapper-div') - paddingOnSourceListWrapper;

    function resizeStage(newPageWidth, newPageHeight) {
      setPageWidth(newPageWidth);
      let newStageWidth = getStageWidth(
        newPageHeight,
        newPageWidth,
        maxWidth,
        otherElementsButStageHeightAndSourceList,
        sourceListHeight
      );
      setStageWidth(newStageWidth);
    }

    function resizeSourceList(newPageHeight) {
      // sourceList height is changed if the pageHeight is less than 1000px
      const newSourceListHeight =
        newPageHeight < 1000 ? 152 : defaultSourceListHeight;
      setSourceListHeight(newSourceListHeight);
    }

    function resizeListener() {
      /**
       * If we are showing network health monitoring stats, then we should
       * not resize stage or source list as it can make stage too small
       * or introduce scroll in attendee video tile list area
       */
      if (!shouldHaveFeature('studio.networkHealthMonitoringStats')) {
        const newPageHeight = getElementHeight('#root');
        const newPageWidth = getElementWidth('#root');
        resizeSourceList(newPageHeight);
        resizeStage(newPageWidth, newPageHeight);
      }
    }

    window.addEventListener('resize', resizeListener);
    resizeListener();
    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, [pageWidth, stageWidth, sourceListHeight]);

  const ratio = 1;

  return { stageWidth, ratio, sourceListHeight };
}

export default useLayoutDimensions;
